import { render, staticRenderFns } from "./ModalAdmin.vue?vue&type=template&id=04bd75e3"
import script from "./ModalAdmin.vue?vue&type=script&lang=js"
export * from "./ModalAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports